import autocomplete from 'autocompleter';
window.autocomplete = autocomplete;

export default autocomplete;
